import { compact } from 'lodash'
import pathToRegexp from 'path-to-regexp'

export default urlPath

function urlPath (...args) {
  const result = compact(args).map((url_part, index) => {
    return index
      ? ('' + url_part).replace(/(^\/)|(\/$)/, '')
      : ('' + url_part).replace(/\/$/, '')
  })

  return result.join('/')
}

export function urlRootPath (...args) {
  return '/' + urlPath(...args).replace(/(^\/)/, '').replace(/(\/$)/, '') + '/'
}

export const compilePath = (path, params = {}) => pathToRegexp.compile(path)(params)
